import { create } from 'zustand'

/**
 * Estado del modal de bienvenida / petición de feedback.
 *
 * <p>El modal invita a dar feedback / reportar bugs mientras la web es nueva.
 * Se abre <strong>en cada inicio de sesión</strong> ({@code openModal} se llama
 * desde el {@code onSuccess} del login) y se cierra al descartarlo (✕,
 * "Entendido", ESC, click fuera o el CTA de feedback).</p>
 *
 * <p>Estado transitorio en memoria — NO se persiste: queremos que reaparezca
 * cada vez que el usuario hace login, no una sola vez por navegador.</p>
 */
interface WelcomeState {
  /** true mientras el modal debe mostrarse. */
  open: boolean
  /** Abre el modal — se llama tras un login exitoso. */
  openModal: () => void
  /** Cierra el modal. */
  close: () => void
}

export const useWelcomeStore = create<WelcomeState>((set) => ({
  open: false,
  openModal: () => set({ open: true }),
  close: () => set({ open: false }),
}))
